import { Gartner } from 'rcd-cpp-ui/ui/icon';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import UserMenu from '../UserMenu/userMenu';
import './header.scss';
import { HelpIcon } from '../Icon/icon';
import { HelpCenter } from '../HelpCenter/helpCenter';
import { Search } from './Search/search';

const Header = () => {
  const [openHelpCenter, setOpenHelpCenter] = React.useState(false);
  return (
    <>
      <nav className="cppw-header navbar navbar-expand">
        <span className="navbar-brand">
          <NavLink to="/">
            <Gartner />
          </NavLink>
        </span>
        <span className="navbar-brand">
          CPP<b>PLANNING</b>
          {process.env.ENV != 'prod' && (
            <label className="envName">
              ({process.env.ENV?.toUpperCase()})
            </label>
          )}
        </span>
        <span className="navbar-text">
          <Search />
          <a onClick={() => setOpenHelpCenter(!openHelpCenter)}>
            <HelpIcon />
          </a>
          <UserMenu />
        </span>
      </nav>
      <HelpCenter
        openHelpCenter={openHelpCenter}
        onCloseForm={async () => await setOpenHelpCenter(!openHelpCenter)}
      />
    </>
  );
};

export default Header;
